export const categories = [
  {
    slug: 'zhishi-jingsai',
    name: '知识竞赛',
    description: '涵盖历史、地理、科学、文学等各领域的知识问答挑战',
    icon: 'ri-lightbulb-line',
    count: 156,
    color: 'primary',
  },
  {
    slug: 'naoli-jingji',
    name: '脑力竞技',
    description: '考验记忆力、逻辑推理、空间想象等脑力能力的综合比拼',
    icon: 'ri-brain-line',
    count: 128,
    color: 'accent',
  },
  {
    slug: 'chuangyi-dasai',
    name: '创意大赛',
    description: '摄影、绘画、写作、设计等创意类作品的每日评选活动',
    icon: 'ri-paint-brush-line',
    count: 94,
    color: 'secondary',
  },
  {
    slug: 'yundong-tiaozhan',
    name: '运动挑战',
    description: '线上运动打卡挑战，跑步、健身、瑜伽等每日运动任务',
    icon: 'ri-run-line',
    count: 112,
    color: 'primary',
  },
  {
    slug: 'youxi-jingji',
    name: '游戏竞技',
    description: '休闲游戏、策略游戏等多类型在线游戏竞技赛事',
    icon: 'ri-gamepad-line',
    count: 203,
    color: 'accent',
  },
  {
    slug: 'yinyue-bisai',
    name: '音乐比赛',
    description: '歌唱、乐器演奏、原创音乐等音乐才艺的每日展示比拼',
    icon: 'ri-music-line',
    count: 87,
    color: 'secondary',
  },
];

export const getCategoryBySlug = (slug: string) => {
  return categories.find((c) => c.slug === slug) || null;
};